// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"f3ea312b","73":"a80a0aa9","113":"d08ce995","180":"af8c6ff3","331":"5b165b6e","344":"96e9b131","555":"075183d3","713":"b208a3a1","780":"920ecfde","818":"d0e8698f","837":"a3eb5d91","900":"acda3354","911":"9762b6d8"}[chunkId] + ".chunk.js";
};